import React, { useEffect, useState } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useSelector, useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { useParams, useSearchParams } from 'react-router-dom'
import { Avatar, Badge, Box, Button, Divider, Flex, Group, Menu, Paper, SimpleGrid, Tabs, Text } from '@mantine/core'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import { IconMessage } from '@tabler/icons-react'
import { getUserDetail } from '../../../../store/userDetail'

// components
import UserGeneral from '../../../../component/pages/Users/Detail/UserGeneral'
import UserMembership from '../../../../component/pages/Users/Detail/UserMembership'
import UserAdditionalInfo from '../../../../component/pages/Users/Detail/UserAdditionalInfo'
import UserCredits from '../../../../component/pages/Users/Detail/UserCredits'
import UserDocuments from '../../../../component/pages/Users/Detail/UserDocuments'
import UserOrders from '../../../../component/pages/Users/Detail/UserOrders'
import UserPoints from '../../../../component/pages/Users/Detail/UserPoints'
import UserRecommendations from '../../../../component/pages/Users/Detail/UserRecommendations'
import UserRelations from '../../../../component/pages/Users/Detail/UserRelations'
import UserTaxInfo from '../../../../component/pages/Users/Detail/UserTaxInfo'
import UserAbandonedCart from '../../../../component/pages/Users/Detail/UserAbandonedCart'

const defaultTab = [
  {
    label: 'General',
    value: 'general'
  },
  {
    label: 'Membership',
    value: 'membership'
  },
  {
    label: 'Tax Infos',
    value: 'tax'
  },
  {
    label: 'Additionals',
    value: 'additionals'
  },
  {
    label: 'ID Documents',
    value: 'verification'
  },
  {
    label: 'Credits',
    value: 'balanceHistory'
  },
  {
    label: 'Points',
    value: 'points'
  },
  {
    label: 'User Relation',
    value: 'relation'
  },
  {
    label: 'Orders',
    value: 'orders'
  },
  {
    label: 'Abandoned Cart',
    value: 'abandoned-cart'
  },
  {
    label: 'Recommendations',
    value: 'recommendations'
  },
]

const defaultPanel = [
  {
    component: UserGeneral,
    value: 'general'
  },
  {
    component: UserMembership,
    value: 'membership'
  },
  {
    component: UserTaxInfo,
    value: 'tax'
  },
  {
    component: UserAdditionalInfo,
    value: 'additionals'
  },
  {
    component: UserDocuments,
    value: 'verification'
  },
  {
    component: UserCredits,
    value: 'balanceHistory'
  },
  {
    component: UserPoints,
    value: 'points'
  },
  {
    component: UserRelations,
    value: 'relation'
  },
  {
    component: UserAbandonedCart,
    value: 'abandoned-cart'
  },
  {
    component: UserOrders,
    value: 'orders'
  },
  {
    component: UserRecommendations,
    value: 'recommendations'
  },
]

const DetailUser = () => {
  const { isLoadingUser, verifiedDataUser, general, activity, membership, verification } = useSelector(state => state.user_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const [searchParams] = useSearchParams()

  const userId = params.id
  const tab = searchParams.get("tab") || ''

  const [activeTab, setActiveTab] = useState('general')

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'users',
      route: '/users/all'
    },
    {
      label: `${userId}`,
      route: null
    },
  ]

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    dispatch(getUserDetail(userId))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    if (tab !== '') {
      setActiveTab(tab)
    }
    // eslint-disable-next-line
  }, [tab])

  const mappingTab = (dataTopTabs) => {
    const remapTopTabs = dataTopTabs.map((val, index) => {
      return (<Tabs.Tab key={index} value={val.value} style={{ color: val.value === activeTab ? 'red' : 'gray', fontWeight: val.value === activeTab ? 'bold' : '400' }}>{val.label}</Tabs.Tab>)
    })
    return remapTopTabs
  }
  const mappingPanel = (dataTopPanels) => {
    const remapTopPanels = dataTopPanels.map((val, index) => {
      return (
        <Tabs.Panel key={`${index}`} value={val.value}>
          <val.component />
        </Tabs.Panel>)
    })
    return remapTopPanels
  }

  const renderUserDetail = () => {
    return (
      <Box>
        {/** Top Section */}
        <Paper shadow="xs" withBorder p="md" radius="lg">
          <Flex gap="sm">
            <Avatar size="xl" radius="100%" name={general.fullName} />

            <Box>
              <Group>
                <Text fz={35} fw={700} tt="capitalize">{ general.fullName }</Text>
                <Menu position="bottom-start" shadow="md" width={300}>
                  <Menu.Target>
                    <Button size='xs'>Share</Button>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Item disabled leftSection={<IconMessage size={14} />}>
                      Broadcast Wa to Internal Group
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Group>
              <SimpleGrid mt={5} cols={5} spacing="xl" verticalSpacing="xs">
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Email</Text>
                  <Text mb={4} fz={14}>{general.email || '-'}</Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Phone Number</Text>
                  <Text mb={4} fz={14}>{general.phone || '-'}</Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Last Login</Text>
                  <Text mb={4} fz={14}>{activity.lastLogin || '-'}</Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Last Session</Text>
                  <Text mb={4} fz={14}>{activity.lastSession || '-'}</Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Account Creation Time</Text>
                  <Text mb={4} fz={14}>{activity.accountCreation}</Text>
                </Box>
              </SimpleGrid>

              <Group mt={20}>
                {
                  membership.memberships.map((val, index) => {
                    return (
                      <Badge key={index} size='md' variant="gradient" gradient={{ from: 'cyan', to: 'blue', deg: 131 }}>
                        {val}
                      </Badge>
                    )
                  })
                }

                <Badge
                  size='md'
                  variant="light"
                  color={verification.nameStatuses === 'verified' ? 'green' : verification.nameStatuses === 'pending for approval' ? 'red' : 'gray'}
                >
                  {verification.nameStatuses}
                </Badge>
              </Group>
            </Box>
          </Flex>
        </Paper>

        <Divider my="md" />

        {/** Menu */}
        <Paper withBorder radius="md" p="md" my={16}>
          <Tabs value={activeTab} onChange={setActiveTab} keepMounted={false}>
            <Tabs.List>
              {mappingTab(defaultTab)}
            </Tabs.List>

            {mappingPanel(defaultPanel)}
          </Tabs>
        </Paper>

      </Box>
    )
  }

  return (
    <AuthLayout>
      <Box my={30}>
        {isLoadingUser ? <LoadingData /> : verifiedDataUser ? renderUserDetail() : <NoData />}
      </Box>
    </AuthLayout>
  )
}

export default DetailUser